import { Fancybox } from "@fancyapps/ui";

export default function initImageGallery(){
  Fancybox.bind("[data-fancybox]");
}
